import { ArrowForward } from "@mui/icons-material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Autocomplete } from "../Autocomplete";

type MatchCampaignFileProps = {
  header: string;
  defaultValue?: any;
  options?: any[];
  onChange?: (data: any) => void;
};

export function MatchCampaignFile({
  header,
  defaultValue,
  options,
  onChange,
}: MatchCampaignFileProps) {
  return (
    <Stack direction="row" spacing={2}>
      <div style={{ width: "30%" }}>
        <Typography color="primary" fontWeight={600}>
          {header}
        </Typography>
      </div>
      <div style={{ width: "100%", textAlign: "center" }}>
        <ArrowForward color="action" />
      </div>

      <Autocomplete
        fullWidth
        size="small"
        label="Coluna"
        options={options}
        defaultValue={defaultValue}
        getOptionLabel={(option) => option.column}
        onChange={(_, option) => {
          onChange(option);
        }}
      />
    </Stack>
  );
}
